import useLogzIo from 'hooks/useLogzIo'
import { useState } from 'react'

const SidebarDirectfulTestLogo = () => {
  const [isErred, setIsErred] = useState(false)

  const log = useLogzIo()

  function handleLoad() {
    log({
      level: 'Info',
      message: 'Reached to directful dashboard'
    })
  }

  function handleError() {
    log({
      level: 'Error',
      message: "Couldn't reach to directful dashboard"
    })
    setIsErred(true)
  }

  if (isErred) return null

  return (
    <img
      src="https://dashboard.directful.com/apple-touch-icon.png"
      alt="logo"
      width={30}
      onLoad={() => handleLoad()}
      onError={() => handleError()}
      height={30}
      style={{ marginLeft: -14, marginRight: 8 }}
    />
  )
}

export default SidebarDirectfulTestLogo
